import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// material-ui
import {
    Button,
    Chip,
    Divider,
    Grid,
    Stack,
    Typography
} from '@mui/material';

import { useTheme } from '@mui/material/styles';

// project imports
import SubCard from 'ui-component/cards/SubCard';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import {
    GetSportsType,
    GetUserType,
    CapFirstChar,
    ChangeCurrencyFormat,
    GetBookingStatus,
    GetPaymentStatus,
    GetTransferStatus
} from 'store/TextFormat';
import useApi from 'hooks/useApi';
import TransactionService from 'services/TransactionService';
import MasterService from 'services/MasterService';
import TasksCard from './TasksCard';

// third party
import moment from 'moment';

const sxDivider = {
    borderColor: 'primary.light'
};


const TransactionDetails = () => {

    const [sportsTypes, setSportsType] = useState([])
    const theme = useTheme();
    const navigate = useNavigate();
    const { bookingUuid } = useParams();
    const [bookingDetails, setBookingDetails] = useState(null);
    const [transactionDetails, setTransactionDetails] = useState(null);

    const handleOnClick = () => {
        navigate(`/transaction`);
    };

    const handleDetailsSuccess = (response) => {
        const data = response.data
        setTransactionDetails(data)
    }

    const getStHandler = (response) => {
        const data = response.data
        setSportsType(data)
    }

    const getTransactionDetailsApi = useApi(TransactionService.getTransactionDetailsByUuid, handleDetailsSuccess);
    const getSportsTypeListApi = useApi(MasterService.getDropdownSportsType, getStHandler)

    useEffect(() => {
        getTransactionDetailsApi.execute(bookingUuid)
    }, [bookingUuid]);

    useEffect(() => {
        if (transactionDetails) {
            setBookingDetails(
                transactionDetails.uuid_venue_booking ? transactionDetails.courtBookingDetails : transactionDetails.boardBookingDetails
            );
        }
    }, [transactionDetails]);

    useEffect(() => {
        getSportsTypeListApi.execute();
    }, []);

    return (

        <MainCard
            title={`Transaction Id: ${transactionDetails ? transactionDetails.transaction_id : ''}`}
            sx={{ border: 0, padding: '0px', margin: '0px' }}
            secondary={
                (<><Button
                    variant="contained"
                    color="secondary"
                    size='small'
                    onClick={() => handleOnClick()}
                >
                    Back
                </Button>
                </>)
            }
        >
            {
                transactionDetails && bookingDetails ? (
                    <Grid container spacing={gridSpacing}>
                        <Grid item xs={7}>
                            <SubCard
                                secondary={
                                    <>
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="subtitle1">Booked By </Typography>
                                            <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                : {`${CapFirstChar(transactionDetails.created_user_firstname)} ${transactionDetails.created_user_lastname ? transactionDetails.created_user_lastname : ''} / ${GetUserType(transactionDetails.created_user_type)}`}
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="subtitle1">Booked On </Typography>
                                            <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                :  {moment(transactionDetails.created_at).format('DD-MM-YYYY hh:mm A')}
                                            </Typography>
                                        </Stack>
                                    </>
                                }
                                title={
                                    <>
                                        {
                                            transactionDetails.courtBookingDetails ? (
                                                <Stack direction="row" spacing={1}>
                                                    <Typography variant="subtitle1">Court Booking Id </Typography>
                                                    <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                        : {transactionDetails.courtBookingDetails.slot_id}
                                                    </Typography>
                                                </Stack>
                                            ) : ('')
                                        }
                                        {
                                            transactionDetails.boardBookingDetails ? (
                                                <Stack direction="row" spacing={1}>
                                                    <Typography variant="subtitle1">Board Booking Id </Typography>
                                                    <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                        : {transactionDetails.boardBookingDetails.code}
                                                    </Typography>
                                                </Stack>
                                            ) : ('')
                                        }
                                        <Stack direction="row" spacing={1}>
                                            <Typography variant="subtitle1">Customer </Typography>
                                            <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                : {`${CapFirstChar(transactionDetails.booked_user_firstname)} ${transactionDetails.booked_user_lastname ? transactionDetails.booked_user_lastname : ''}`} ({transactionDetails.booked_user_code})
                                            </Typography>
                                        </Stack>
                                    </>
                                }
                            >
                                <Grid container spacing={gridSpacing}>
                                    <Grid item xs={12}>
                                        <Grid container spacing={gridSpacing}>
                                            <Grid item>
                                                <Stack spacing={2}>
                                                    <Typography variant="h4">Booking Details</Typography>
                                                    <Stack spacing={0}>
                                                        <Stack direction="row" spacing={1}>
                                                            <Typography variant="subtitle1">Venue Name </Typography>
                                                            <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                : {bookingDetails.venue_name}
                                                            </Typography>
                                                        </Stack>
                                                        <Stack direction="row" spacing={1}>
                                                            <Typography variant="subtitle1">Court Name </Typography>
                                                            <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                : {bookingDetails.turf_name}
                                                            </Typography>
                                                        </Stack>
                                                        {
                                                            transactionDetails.uuid_board_booking && transactionDetails.boardBookingDetails ? (
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="subtitle1">Board Name </Typography>
                                                                    <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                        : {transactionDetails.boardBookingDetails.board_name}</Typography>
                                                                </Stack>
                                                            ) : (<></>)
                                                        }
                                                    </Stack>
                                                </Stack>
                                            </Grid>
                                            {
                                                transactionDetails.uuid_venue_booking && transactionDetails.courtBookingDetails ? (
                                                    <Grid item>
                                                        <Stack spacing={2}>
                                                            <Typography variant="h4">&nbsp;</Typography>
                                                            <Stack spacing={0}>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="subtitle1">Court Duration </Typography>
                                                                    <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                        : {bookingDetails.duration} mins
                                                                    </Typography>
                                                                </Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="subtitle1">Start Time </Typography>
                                                                    <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                        : {moment(bookingDetails.start_date).format('DD-MM-YYYY')} {moment(bookingDetails.start_date + ' ' + bookingDetails.start_time + ':00', 'YYYY-MM-DD HH:mm:ss').format('hh:mm A')}
                                                                    </Typography>
                                                                </Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="subtitle1">End Time </Typography>
                                                                    <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                        : {moment(bookingDetails.end_date).format('DD-MM-YYYY')} {moment(bookingDetails.start_date + ' ' + bookingDetails.start_time + ':00', 'YYYY-MM-DD HH:mm:ss').add(parseInt(bookingDetails.duration), 'minutes').format('hh:mm A')}
                                                                    </Typography>
                                                                </Stack>
                                                            </Stack>
                                                        </Stack>
                                                    </Grid>
                                                ) : ('')
                                            }
                                            {
                                                transactionDetails.uuid_board_booking && transactionDetails.boardBookingDetails ? (
                                                    <Grid item>
                                                        <Stack spacing={2}>
                                                            <Typography variant="h4">&nbsp;</Typography>
                                                            <Stack spacing={0}>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="subtitle1">Board Duration </Typography>
                                                                    <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                        : {transactionDetails.boardBookingDetails.duration} mins
                                                                    </Typography>
                                                                </Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="subtitle1">Start Time </Typography>
                                                                    <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                        : {moment(transactionDetails.boardBookingDetails.start_date).format('DD-MM-YYYY')} {moment(transactionDetails.boardBookingDetails.start_date + ' ' + transactionDetails.boardBookingDetails.start_time + ':00', 'YYYY-MM-DD HH:mm:ss').format('hh:mm A')}
                                                                    </Typography>
                                                                </Stack>
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="subtitle1">End Time </Typography>
                                                                    <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                        : {moment(transactionDetails.boardBookingDetails.end_date.replace('T', ' ').replace('.000Z', '')).format('DD-MM-YYYY')} {moment(transactionDetails.boardBookingDetails.start_date + ' ' + transactionDetails.boardBookingDetails.start_time + ':00', 'YYYY-MM-DD HH:mm:ss').add(parseInt(transactionDetails.boardBookingDetails.duration), 'minutes').format('hh:mm A')}
                                                                    </Typography>
                                                                </Stack>
                                                            </Stack>
                                                        </Stack>
                                                    </Grid>
                                                ) : (<></>)
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Divider sx={sxDivider} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={gridSpacing}>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Stack spacing={2}>
                                                    {/* <Typography variant="h4"></Typography> */}
                                                    <Stack spacing={0}>
                                                        <Stack direction="row" spacing={1}>
                                                            <Typography variant="subtitle1">Payment Type :</Typography>
                                                            <Typography variant="subtitle1" sx={{ marginTop: '0px !important', marginBottom: '4px !important' }}>
                                                                {
                                                                    bookingDetails.payment_type === 'offline' ? (
                                                                        <Chip
                                                                            label={CapFirstChar(bookingDetails.payment_type)}
                                                                            size="small"
                                                                            sx={{
                                                                                background:
                                                                                    theme.palette.mode === 'dark'
                                                                                        ? theme.palette.dark.main
                                                                                        : theme.palette.primary.light + 60,
                                                                                color: theme.palette.primary.dark
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <Chip
                                                                            label={CapFirstChar(bookingDetails.payment_type)}
                                                                            size="small"
                                                                            sx={{
                                                                                background:
                                                                                    theme.palette.mode === 'dark'
                                                                                        ? theme.palette.dark.main
                                                                                        : theme.palette.secondary.light + 60,
                                                                                color: theme.palette.secondary.dark
                                                                            }}
                                                                        />
                                                                    )
                                                                }
                                                            </Typography>
                                                        </Stack>
                                                        <Stack direction="row" spacing={1}>
                                                            <Typography variant="subtitle1">Payment Mode :</Typography>
                                                            <Typography variant="subtitle1" sx={{ marginTop: '0px !important', marginBottom: '4px !important' }}>
                                                                {
                                                                    bookingDetails.payment_mode === 'full' ? (
                                                                        <Chip
                                                                            label={CapFirstChar(bookingDetails.payment_mode)}
                                                                            size="small"
                                                                            sx={{
                                                                                background:
                                                                                    theme.palette.mode === 'dark'
                                                                                        ? theme.palette.dark.main
                                                                                        : theme.palette.primary.light + 60,
                                                                                color: theme.palette.primary.dark
                                                                            }}
                                                                        />
                                                                    ) : bookingDetails.payment_mode === 'na' ? '-' : (
                                                                        <Chip
                                                                            label={CapFirstChar(bookingDetails.payment_mode)}
                                                                            size="small"
                                                                            sx={{
                                                                                background:
                                                                                    theme.palette.mode === 'dark'
                                                                                        ? theme.palette.dark.main
                                                                                        : theme.palette.secondary.light + 60,
                                                                                color: theme.palette.secondary.dark
                                                                            }}
                                                                        />
                                                                    )
                                                                }
                                                            </Typography>
                                                        </Stack>
                                                        {
                                                            bookingDetails.sports_type ? (
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="subtitle1">Sports Type :</Typography>
                                                                    <Typography variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                        {GetSportsType(sportsTypes, bookingDetails.sports_type)}
                                                                    </Typography>
                                                                </Stack>
                                                            ) : ('')
                                                        }
                                                    </Stack>
                                                </Stack>
                                            </Grid>
                                            <Grid item xs={12} sm={6} md={4}>
                                                <Stack spacing={2}>
                                                    {/* <Typography variant="h4">Status</Typography> */}
                                                    <Stack spacing={0}>
                                                        <Stack direction="row" spacing={1}>
                                                            <Typography variant="subtitle1">Booking Status :</Typography>
                                                            <Typography variant="subtitle1" sx={{ marginTop: '0px !important', marginBottom: '4px !important' }}>
                                                                <Chip
                                                                    label={GetBookingStatus(bookingDetails.booking_status)}
                                                                    size="small"
                                                                    sx={{
                                                                        background:
                                                                            bookingDetails.booking_status === 'confirmed' ? theme.palette.success.light + 60 :
                                                                                bookingDetails.booking_status === 'cancelled' ? theme.palette.error.light + 60 :
                                                                                    bookingDetails.booking_status === 'blocked' || bookingDetails.booking_status === 'reserved' ? theme.palette.warning.light + 60 :
                                                                                        theme.palette.info.light + 60,
                                                                        color: bookingDetails.booking_status === 'confirmed' ? theme.palette.success.dark :
                                                                            bookingDetails.booking_status === 'cancelled' ? theme.palette.error.dark :
                                                                                bookingDetails.booking_status === 'blocked' || bookingDetails.booking_status === 'reserved' ? theme.palette.warning.dark :
                                                                                    theme.palette.info.dark,
                                                                    }}
                                                                />
                                                            </Typography>
                                                        </Stack>
                                                        <Stack direction="row" spacing={1}>
                                                            <Typography variant="subtitle1">Payment Status :</Typography>
                                                            <Typography variant="body2" sx={{ marginTop: '4px !important' }}>
                                                                <Chip
                                                                    label={GetPaymentStatus(bookingDetails.payment_status)}
                                                                    size="small"
                                                                    sx={{
                                                                        background:
                                                                            bookingDetails.payment_status === 'confirmed' ? theme.palette.success.light + 60 :
                                                                                bookingDetails.payment_status === 'cancelled' ? theme.palette.error.light + 60 :
                                                                                    bookingDetails.payment_status === 'reserved' ? theme.palette.info.light + 60 :
                                                                                        theme.palette.warning.light + 60,
                                                                        color: bookingDetails.payment_status === 'confirmed' ? theme.palette.success.dark :
                                                                            bookingDetails.payment_status === 'cancelled' ? theme.palette.error.dark :
                                                                                bookingDetails.payment_status === 'reserved' ? theme.palette.info.dark :
                                                                                    theme.palette.warning.dark,
                                                                    }}
                                                                />
                                                            </Typography>
                                                        </Stack>{
                                                            transactionDetails.booking_type ? (<></>) : (
                                                                <Stack direction="row" spacing={1}>
                                                                    <Typography variant="subtitle1">Transfer Status :</Typography>
                                                                    <Typography variant="body2" sx={{ marginTop: '4px !important' }}>
                                                                        <Chip
                                                                            label={GetTransferStatus(transactionDetails.transfer_status)}
                                                                            size="small"
                                                                            sx={{
                                                                                background:
                                                                                    transactionDetails.transfer_status === 'completed' || transactionDetails.transfer_status === 'reversed' ? theme.palette.success.light + 60 :
                                                                                        transactionDetails.transfer_status === 'cancelled' ? theme.palette.error.light + 60 :
                                                                                            theme.palette.warning.light + 60,
                                                                                color: transactionDetails.transfer_status === 'completed' || transactionDetails.transfer_status === 'reversed' ? theme.palette.success.dark :
                                                                                    transactionDetails.transfer_status === 'cancelled' ? theme.palette.error.dark :
                                                                                        theme.palette.warning.dark,
                                                                            }}
                                                                        />
                                                                    </Typography>
                                                                </Stack>)
                                                        }

                                                    </Stack>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <SubCard>
                                            <Grid container justifyContent="flex-end" spacing={gridSpacing}>
                                                <Grid item sm={6} md={5}>
                                                    <Grid container spacing={2} sx={{
                                                        mx: 0,
                                                        mb: 3,
                                                        px: 1,
                                                        bgcolor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
                                                    }}>
                                                        <Grid item xs={12}>
                                                            <Grid container spacing={1}>
                                                                {
                                                                    bookingDetails.actual_slot_price > 0 && (
                                                                        <>
                                                                            <Grid item xs={9}>
                                                                                <Typography align="right" variant="subtitle1">
                                                                                    Original Amount : &#8377;
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <Typography align="right" variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                                    {bookingDetails.actual_slot_price > 0 ? ChangeCurrencyFormat(bookingDetails.actual_slot_price) : 0.00}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </>
                                                                    )
                                                                }
                                                                {
                                                                    bookingDetails.scoreboard_amount > 0 && bookingDetails.scoreboard_amount > 0 ? (
                                                                        <>
                                                                            <Grid item xs={9}>
                                                                                <Typography align="right" variant="subtitle1">
                                                                                    Board Amount : &#8377;
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <Typography align="right" variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                                    {bookingDetails ? ChangeCurrencyFormat(bookingDetails.scoreboard_amount) : 0.00}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </>
                                                                    ) : ('')
                                                                }
                                                                <Grid item xs={9}>
                                                                    <Typography align="right" variant="subtitle1">
                                                                        {bookingDetails.payment_mode === 'full' ? 'Sub Total' : 'Advance'} : &#8377;
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                    <Typography align="right" variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                        {bookingDetails.subtotal > 0 ? ChangeCurrencyFormat(bookingDetails.subtotal) : 0.00}
                                                                    </Typography>
                                                                </Grid>
                                                                {
                                                                    bookingDetails.payment_mode === 'cash' ? ('') : bookingDetails.convenience_fee > 0 ? (
                                                                        <>
                                                                            <Grid item xs={9}>
                                                                                <Typography align="right" variant="subtitle1">
                                                                                    Convenience Fee : &#8377;
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <Typography align="right" variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                                    {bookingDetails ? ChangeCurrencyFormat(bookingDetails.convenience_fee) : 0.00}
                                                                                </Typography>
                                                                            </Grid>
                                                                        </>
                                                                    ) : ('')
                                                                }
                                                                {
                                                                    bookingDetails.discount_amount > 0 ? (
                                                                        <>
                                                                            <Grid item xs={9}>
                                                                                <Typography align="right" variant="subtitle1">
                                                                                    Discount : &#8377;
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid item xs={3}>
                                                                                <Typography align="right" variant="body2" sx={{ marginTop: '2px !important' }}>
                                                                                    {bookingDetails ? ChangeCurrencyFormat(bookingDetails.discount_amount) : 0.00}
                                                                                </Typography>
                                                                            </Grid>

                                                                        </>
                                                                    ) : ('')
                                                                }
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Divider sx={{ bgcolor: 'dark.main' }} />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <Grid container spacing={1}>
                                                                <Grid item xs={9}>
                                                                    <Typography align="right" color="primary" variant="subtitle1">
                                                                        Total : &#8377;
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={3}>
                                                                    <Typography align="right" color="primary" variant="subtitle1">
                                                                        {bookingDetails.total > 0 ? ChangeCurrencyFormat(bookingDetails.total) : 0.00}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </SubCard>
                                    </Grid>
                                </Grid>
                            </SubCard>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <TasksCard title="Booking Log" history={transactionDetails.history} />
                        </Grid>
                    </Grid>
                ) : (<></>)
            }
        </MainCard>
    );
};

export default TransactionDetails;
